import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {
  usePropertiesExistsQuery,
  useLazyPropertiesExistsQuery,
} from '../api/main/property';

function useHasProperties() {
  const {loggedIn, userVerified} = useSelector(state => state.auth);

  const verified = loggedIn === true && userVerified === true;

  const {
    data: hasProperties = false,
    isLoading,
    isFetching,
  } = usePropertiesExistsQuery(undefined, {skip: !verified});

  const [trigger] = useLazyPropertiesExistsQuery();

  const refresh = useCallback(
    () =>
      trigger(undefined, false)
        .unwrap()
        .catch(() => false),
    [trigger]
  );

  return {hasProperties, isLoading, isFetching, refresh};
}

export default useHasProperties;
